import React, { useEffect } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import GlobalClassFile from "../popups/GlobalClassFile";
import Debug from "./Debug";
import EmployeeLogin from "../popups/EmployeeLogin";
import Setup from "../popups/Setup";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import InventoryController from "./InventoryController";
import { createScreen } from "../hooks/createScreen";
import DocumentationController from "./DocumentationController";
import { createEmpty } from "../hooks/createEmpty";
import InventorySearch from "../popups/InventorySearch";
import { getSignal } from "../App";
import InventoryOrder from "../components/InventoryOrder";
import ReconciliationController from "./ReconciliationController";
import { kbdEvent } from "../utils/Utils";



let inventory_loaded = false;
let order_loaded = false;
// Only load one instance of this...
export const loadInventory = (_keyboard_event) => {
    if (inventory_loaded) {
        showMessage("Inventory Already Loaded")
        return;
    } else {
        inventory_loaded = true;
    }
    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = "global";
    const signal = getSignal();
    createScreen({
        signal: signal,
        component: <InventoryController controller={"global"} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
        callback: (_obj) => {
            window.ac = origin_controller;
            window.bm_state.value = origin;
            inventory_loaded = false;
            _keyboard_event?.target?.focus?.();
        }
    });
}


export const drawOrder = () => {




    if (order_loaded) {
        showError({ error: "Inventory Already Loaded" })
        return;
    } else {
        order_loaded = true;
    }


    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = "global";
    const signal = getSignal();
    window.bm_state.value = ROUTES.INVENTORY.ORDER
    createModal({
        component: <InventoryOrder route={ROUTES.INVENTORY.ORDER} controller={"global"} />, closable: true, title: "Order",
        callback: (e) => {
            order_loaded = false;
        }
    });

}


export const drawProductSearch = (_keyboard_event) => {

    if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
        setTimeout(() => {
            kbdEvent(KBD.S);
        }, 50)
        return;
    }


    if (inventory_loaded) {
        showError({ error: "Inventory Already Loaded" })
        return;
    } else {
        inventory_loaded = true;
    }


    const origin = window.bm_state.value;
    const origin_controller = window.ac;
    window.ac = "global";
    const signal = getSignal();
    window.bm_state.value = ROUTES.INVENTORY.SEARCH
    createModal({
        component: <InventorySearch controller={"global"} setStock={() => { }} selected={{}} route={ROUTES.INVENTORY.SEARCH} />, closable: true, title: "Product Search",
        callback: (e, _searchMsg) => {
            // Manual close

            if (!e) {
                window.bm_state.value = origin;
                window.ac = origin_controller;
                inventory_loaded = false;

                _keyboard_event?.target?.focus?.();
                return;
            } else {
                window.bm_state.value = ROUTES.INVENTORY.INVENTORY
                createScreen({
                    signal: signal,
                    component: <InventoryController controller={"global"} search={{ results: e, message: _searchMsg }} is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
                    callback: (_obj) => {
                        window.bm_state.value = origin;
                        window.ac = origin_controller;
                        inventory_loaded = false;
                        _keyboard_event?.target?.focus?.();
                    }
                });
            }
            return;
        }
    });
}


export default function GlobalController(props) {

    const { signal = {}, WS_ONLY = false, controller = "", setController = () => { } } = props;


    const drawInventory = () => {
        if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            return;
        }
        const origin = window.bm_state.value;
        createScreen({
            signal: signal,
            component: <InventoryController controller={controller} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.INVENTORY.INVENTORY} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = origin;
            }
        });

    }


    const drawReconciliation = () => {
        if (window.bm_state.value === ROUTES.RECONCILIATION.RECONCILIATION) {
            return;
        }
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
        createScreen({
            signal: signal,
            component: <ReconciliationController controller={controller} flag="global" is_global={true} setController={() => { }} signal={signal} route={ROUTES.RECONCILIATION.RECONCILIATION} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = origin;
            }
        });

    }




    const drawClassFile = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <GlobalClassFile controller={controller} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Classification File", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawDebug = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
        createModal({
            component: <Debug controller={controller} route={ROUTES.GLOBAL.CLASSFILE} />, closable: true, title: "Debug", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawLogin = () => {

        // Logout if already logged in
        if (signal?.value?.session?.clerk_code) {
            pubCall("employee.logout", {}, (_s, _r) => {
                if (_s) {
                    signal.value = { ...signal.value, "session": _r }
                    showMessage("Active user has been logged out.")
                } else {
                    showError(_r);
                }
            })
            return;
        }

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
        createModal({
            component: <EmployeeLogin controller={controller} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: "Login", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawSetup = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createModal({
            component: <Setup controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP} />, closable: true, title: "Setup Options", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }


    const drawDocs = () => {

        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP;
        createEmpty({
            component: <DocumentationController controller={controller} signal={signal} route={ROUTES.GLOBAL.DOCS} />, closable: true, title: "Docs", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }


    useEffect(() => {
        const onDrawReconciliation = (e) => drawReconciliation(e.detail);
        window.addEventListener("drawReconciliation", onDrawReconciliation);
        return () => {
            window.removeEventListener("drawReconciliation", onDrawReconciliation);
        }
    }, []);



    useEffect(() => {

        const actions = [

            { key: KBD.F1, action: (e) => { drawDebug() } },
            { key: KBD.F5, action: (e) => { drawOrder() } },
            { key: KBD.F2, action: (e) => { if (!WS_ONLY) { drawProductSearch(e) } } },
            { key: KBD.F4, action: (e) => { drawClassFile() } },
            { key: KBD.F6, action: (e) => { drawLogin() } },
            { key: KBD.F8, action: (e) => { drawDocs() } },
            { key: KBD.RECONCILIATION, action: (e) => { drawReconciliation() } },
            //  { key: KBD.F5, action: (e) => { drawLogin() } },
            { key: KBD.ALT_S, action: (e) => { drawSetup() } },


        ];
        const cleanup = listen("", ROUTES.GLOBAL.GLOBAL, actions, false);
        return cleanup;
    }, []);


    return (<></>)
}